export enum VerificationMethod {
  // Whatsapp = 'Whatsapp',
  Email = 'Email',
  // WhatsappAndEmail = 'WhatsappAndEmail',
}
